import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureFlagWidgetComponent, FeatureFlagComponent } from './components';

@NgModule({
  imports: [CommonModule],
  declarations: [FeatureFlagWidgetComponent, FeatureFlagComponent],
  exports: [FeatureFlagWidgetComponent, FeatureFlagComponent]
})
export class FeatureFlagModule {}
